import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var AncillariesTapService = /** @class */ (function () {
    function AncillariesTapService(_http) {
        this._http = _http;
        this._ancillariesLoaded = false;
        this._observableAncillaries = new BehaviorSubject(this.ancillaries);
    }
    Object.defineProperty(AncillariesTapService.prototype, "ancillariesLoaded", {
        get: function () {
            return this._ancillariesLoaded;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AncillariesTapService.prototype, "observableAncillaries", {
        get: function () {
            return this._observableAncillaries;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AncillariesTapService.prototype, "ancillaries", {
        get: function () {
            return this._ancillaries;
        },
        set: function (ancillaries) {
            this._ancillaries = ancillaries;
        },
        enumerable: true,
        configurable: true
    });
    /** Reads JSON file and import mock data for ancillaries */
    AncillariesTapService.prototype.readAncillariesInitializerFile = function () {
        var url = './assets/data/ancillaries.json';
        var filePromise = this._http.get(url).toPromise();
        return filePromise;
    };
    /** Reads JSON file and import mock data for ancillaries */
    AncillariesTapService.prototype.readConfirmationAncillariesInitializerFile = function () {
        var url = './assets/data/ancillaries-confirmation.json';
        var filePromise = this._http.get(url).toPromise();
        return filePromise;
    };
    AncillariesTapService.prototype.ancillariesInitializerFile = function () {
        var url = './assets/data/ancillaries.json';
        return this._http.get(url);
    };
    AncillariesTapService.ngInjectableDef = i0.defineInjectable({ factory: function AncillariesTapService_Factory() { return new AncillariesTapService(i0.inject(i1.HttpClient)); }, token: AncillariesTapService, providedIn: "root" });
    return AncillariesTapService;
}());
export { AncillariesTapService };
